/**
 * Service categories group a location's services. A category is nothing but a
 * name scoped to a location — the grouping itself lives on the service, as
 * `categoryId`. Renaming a category rewrites the denormalised `category` name
 * onto every service filed under it, and deleting one leaves its services in
 * place with no category.
 */
export interface ServiceCategory {
	id: number;
	locationId: number;
	name: string;
	/** Services filed under this category, counted by the backend. */
	serviceCount: number;
	createdAt: string;
	updatedAt: string;
}

/** Body for both create and rename — the name is the whole of a category. */
export interface ServiceCategoryRequest {
	name: string;
}

/** Body for filing several services under one category in a single call. */
export interface AssignServicesRequest {
	serviceIds: number[];
}

/**
 * The backend column is an unbounded string, so this cap is a client-side
 * guard rather than a mirror of a server constraint.
 */
export const CATEGORY_NAME_MAX_LENGTH = 150;

/**
 * Which services the list is showing. `'all'` and `'uncategorized'` are derived
 * client-side; a number is a real category id.
 */
export type CategoryFilter = 'all' | 'uncategorized' | number;
